import React, { useState, useEffect, useContext, Fragment } from 'react';
import AlertaContext from '../../context/alertas/alertaContext';
import AuthContext from '../../context/autenticacion/authContext';
import ProspectoContext from '../../context/doctores/prospectos/prospectoContext';
import TopBar from '../layout/TopBar';
import AsyncSelect from 'react-select/lib/Async';
import { Link } from 'react-router-dom';

const Prospecto = ( props ) => {

    const alertaContext = useContext( AlertaContext );
    const { alerta } = alertaContext;

    const authContext = useContext( AuthContext );
    const { usuarioAPIAutenticado } = authContext;

    const prospectoContext = useContext( ProspectoContext );
    const { cargando, prospectos, obtenerEmpresas, guardarProspecto, obtenerProspectos } = prospectoContext;

    const doctorId = JSON.parse( localStorage.getItem( 'usuario' ) ).entidadId;

    useEffect( () => {
        usuarioAPIAutenticado(1);

        buscarCliente( '' );

        //eslint-disable-next-line
    },[] );

    const [prospecto, setProspecto] = useState( {
        contactoId: 0,
        entidadId: 0,
        nombre: '',
        apellido_paterno: '',
        apellido_materno: '',
        calle: '',
        noExterior: '',
        noInterior: '',
        colonia: '',
        codigoPostal: '',
        telefonoPrincipal: '',
        telefonoMovil: '',
        rfc: '',
        email: '',
        aniversario: '',
        genero: 0,
        entidadPadre: null,
        buscar: '',
        esPacienteDoctorActual: true
    } );

    const { 
        contactoId,
        entidadId,
        nombre,
        apellido_paterno,
        apellido_materno,
        calle,
        noExterior,
        noInterior,
        colonia,
        codigoPostal,
        telefonoPrincipal,
        telefonoMovil,
        rfc,
        email,
        aniversario,
        genero,
        entidadPadre,
        buscar,
        esPacienteDoctorActual
     } = prospecto;
     
     const formatDate = date => {
    
        let fechaHora = date.split( ' ' );

        let fecha = fechaHora[0].split( '-' );

        let format = ( fechaHora.length > 1 ) ? 
                        `${fecha[2]}/${fecha[1]}/${fecha[0]} ${fechaHora[1]} ${fechaHora[2]}`
                        :
                        `${fecha[2]}/${fecha[1]}/${fecha[0]}`

        return format;

    }

    

    const cargarEmpresas = async ( search ) => {
        let data = null;
        if( search.length === 0 || search.length > 2 ) {
            let filtro = search.length > 0 ? search : 'all';
            data = obtenerEmpresas( filtro );
        }
        
        return data;
    }

    const buscarCliente = async ( texto ) => {
        if( texto.length === 0 || texto.length > 2 ) {
            let filtro = texto.length > 0 ? texto : 'all';
            obtenerProspectos( doctorId, filtro );
        }
    }

    const handleChange = e => {
        setProspecto( {
            ...prospecto,
            [e.target.name]: e.target.value
        } );

        if( e.target.name === 'buscar' ){
            buscarCliente( e.target.value )
        }
    }

    const onChangeEmpresa = e => {
        setProspecto( {
            ...prospecto,
            entidadPadre: e
        } );
    }

    const onSelectEdit = ( e, data ) => {
        e.preventDefault();

        const date = new Date( data.aniversario );
        date.setDate(date.getDate() + 1);

        var edad = `${date.getFullYear()}-${(date.getMonth()+1 < 10) ? '0':''}${date.getMonth()+1}-${(date.getDate() < 10) ? '0' : ''}${date.getDate()}`;

        setProspecto( {
            ...prospecto,
            entidadId: data.entidadId,
            nombre: data.nombre,
            apellido_paterno: data.apellido_paterno,
            apellido_materno: data.apellido_materno,
            calle: data.calle,
            noExterior: data.noExterior,
            noInterior: data.noInterior,
            colonia: data.colonia,
            codigoPostal: data.codigoPostal,
            telefonoPrincipal: data.telefonoPrincipal,
            telefonoMovil: data.telefonoMovil,
            rfc: data.rfc,
            email: data.email,
            aniversario: edad,
            genero: data.genero,
            entidadIPadre: data.entidadIdPadre,
            entidadPadre: {value: data.entidadIdPadre, label: data.clasificacionNombre, Nombre: data.clasificacionNombre},
            esPacienteDoctorActual: data.esPacienteDoctorActual === 1 ? true : false
        } );
    }

    const limpiarForm = () => {
        setProspecto( {
            ...prospecto,
            entidadId: 0,
            nombre: '',
            apellido_paterno: '',
            apellido_materno: '',
            calle: '',
            noExterior: '',
            noInterior: '',
            colonia: '',
            codigoPostal: '',
            telefonoPrincipal: '',
            telefonoMovil: '',
            rfc: '',
            email: '',
            aniversario: '',
            genero: 0,
            entidadPadre: null,
            buscar: '',
            esPacienteDoctorActual: true
        } );
    }

    const onSubmit = e => {
        e.preventDefault();

         let data = {
             encabezado: {
                contactoId: entidadId != 0 ?  entidadId : contactoId,
                entidadId,
                nombre,
                apellido_paterno,
                apellido_materno,
                clasificacionId: 35016,
                calle,
                noExterior,
                noInterior,
                colonia,
                codigoPostal,
                telefonoPrincipal,
                telefonoMovil,
                rfc,
                email,
                aniversario: aniversario ? formatDate( aniversario ) : '',
                genero,
                entidadIdPadre: entidadPadre ? entidadPadre.value : 0
            }
        }

        guardarProspecto( data );

        /*if( !error && !cargando ) {
            buscarCliente( '' );
            limpiarForm();

            window.location.reload(false);
        } else {
            e.target.className += " was-validated";
        }*/
    }

    return ( 
        <div>
            <TopBar />
            <div className="container-fluid">
                { alerta ? ( <div className={`alert ${alerta.categoria} alert-dismissible fade in`}> { alerta.msg } </div> ) : null }
                <form className="needs-validation" onSubmit={onSubmit} noValidate>
                    <div className="row">
                        <div className="col-md-1">
                        </div>
                        <div className="col-md-3">
                            <h3>Registro de cliente</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-1">
                        </div>
                        <div className="col-md-3" style={{backgroundColor:'white'}}>
                            <div className="row mt-2">
                                <div className="col">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Buscar cliente"
                                        id="buscar"
                                        name="buscar"
                                        value={buscar}
                                        onChange={handleChange} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="d-flex" style={{top:'45px', bottom:'0', left:'0', right:'0', position: 'absolute', overflowY: 'scroll', overflowX: 'hidden'}}>
                                    <div className="col">
                                        {
                                            !prospectos ?
                                            <div className="text-center">
                                                No hay registros
                                            </div> :
                                            prospectos.map( (p, index ) => (
                                                <div key={index} className="row" style={{borderBottom: '1px solid gray'}}>
                                                    <div className="col-10">
                                                        <strong>{p.nombreCompleto}</strong><br/>
                                                        { p.esPacienteDoctorActual === 1 ?
                                                         <strong><small>Edad: {p.edad} años</small></strong> :
                                                         null} 
                                                    </div>
                                                    <div className="col-2 text-center justify-content-center align-self-center">
                                                        <a href="#!" onClick={( event ) => { onSelectEdit( event, p ) }}>
                                                            <span className="material-icons">edit</span>
                                                        </a>
                                                    </div>
                                                </div>
                                            ) )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-7 ml-2" style={{backgroundColor:'white'}}>
                            <div className="row">
                                <div className="col">
                                    <h4>Información básica</h4>
                                </div>
                                <div className="col text-right justify-content-center align-self-center">
                                    <button
                                        type="button"
                                        className={`btn btn-primary ${(entidadId === 0) ? 'disabled' : '' }`}
                                        disabled={entidadId === 0 ? true : false}
                                        onClick={limpiarForm}>
                                            Nuevo
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col">
                                    <label htmlFor="nombre">Nombre(s)</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="nombre"
                                        name="nombre"
                                        value={nombre}
                                        onChange={handleChange}
                                        required />
                                    <div className="invalid-feedback">
                                        Este campo es obligatorio
                                    </div>
                                </div>
                                <div className="col">
                                    <label htmlFor="apellido_paterno">Apellido paterno</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="apellido_paterno"
                                        name="apellido_paterno"
                                        value={apellido_paterno}
                                        onChange={handleChange}
                                        required />
                                    <div className="invalid-feedback">
                                        Este campo es obligatorio
                                    </div>
                                </div>
                                <div className="col">
                                    <label htmlFor="apellido_materno">Apellido materno</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="apellido_materno"
                                        name="apellido_materno"
                                        value={apellido_materno}
                                        onChange={handleChange}
                                        required />
                                    <div className="invalid-feedback">
                                        Este campo es obligatorio
                                    </div>
                                </div>
                            </div>
                            { esPacienteDoctorActual ? 
                            <Fragment>
                            <div className="row mt-4">
                                <div className="form-group col">
                                    <label htmlFor="calle">Calle</label><small> (Opcional)</small>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="calle"
                                        name="calle"
                                        value={calle}
                                        onChange={handleChange} />
                                </div>
                                <div className="col">
                                    <label htmlFor="noExterior">Número exterior</label><small> (Opcional)</small>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="noExterior"
                                        name="noExterior"
                                        value={noExterior}
                                        onChange={handleChange} />
                                </div>
                                <div className="col">
                                    <label htmlFor="noInterior">Número interior</label><small> (Opcional)</small>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="noInterior"
                                        name="noInterior"
                                        value={noInterior}
                                        onChange={handleChange} />
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col">
                                    <label htmlFor="colonia">Colonia</label><small> (Opcional)</small>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="colonia"
                                        name="colonia"
                                        value={colonia}
                                        onChange={handleChange} />
                                </div>
                                <div className="col">
                                    <label htmlFor="codigoPostal">Código postal</label><small> (Opcional)</small>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="codigoPostal"
                                        name="codigoPostal"
                                        value={codigoPostal}
                                        onChange={handleChange} />
                                </div>
                                <div className="col">
                                </div>
                            </div>
                            <div className="row mt-4">
                                <div className="col">
                                    <label htmlFor="telefonoPrincipal">Teléfono</label><small> (Opcional)</small>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="telefonoPrincipal"
                                        name="telefonoPrincipal"
                                        value={telefonoPrincipal}
                                        onChange={handleChange} />
                                </div>
                                <div className="col">
                                    <label htmlFor="telefonoMovil">Celular</label><small> (Opcional)</small>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="telefonoMovil"
                                        name="telefonoMovil"
                                        value={telefonoMovil}
                                        onChange={handleChange} />
                                </div>
                                <div className="col">
                                    <label htmlFor="rfc">RFC</label><small> (Opcional)</small>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="rfc"
                                        name="rfc"
                                        value={rfc}
                                        onChange={handleChange} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col"><hr/></div>
                            </div>
                            <div className="row mt-4">
                                <div className="col">
                                    <label htmlFor="email">Correo electrónico</label><small> (Opcional)</small>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="email"
                                        name="email"
                                        value={email}
                                        onChange={handleChange}
                                        required />
                                    <div className="invalid-feedback">
                                        Este campo es obligatorio
                                    </div>
                                </div>
                                <div className="col">
                                    <label htmlFor="aniversario">Fecha de nacimiento</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        id="aniversario"
                                        name="aniversario"
                                        value={aniversario}
                                        onChange={handleChange}
                                        required />
                                    <div className="invalid-feedback">
                                        Este campo es obligatorio
                                    </div>
                                </div>
                                <div className="col">
                                    <label htmlFor="genero">Sexo </label>
                                    <select className="form-control form-control-lg" id="genero" name="genero" value={genero} onChange={handleChange} required>
                                        <option value="0">Seleccione...</option>
                                        <option value="1">Masculino</option>
                                        <option value="2">Femenino</option>
                                    </select>
                                    <div className="invalid-feedback">
                                        Este campo es obligatorio
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col">
                                    <label htmlFor="entidadPadre">Empresa a la que pertenece </label><small>(Opcional)</small>
                                    <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        minimumInput={2}
                                        loadOptions={cargarEmpresas}
                                        value={entidadPadre}
                                        onChange={onChangeEmpresa}
                                        placeholder="Seleccione..." />
                                </div>
                                <div className="col">
                                </div>
                            </div>
                            </Fragment>
                            : <Fragment>
                                <div className="row mt-4"></div>
                                <div className="row mt-4"></div>
                                <div className="row mt-4"></div>
                                <div className="row mt-4"></div>
                                <div className="row mt-4"></div>
                            </Fragment>
                            }
                            <div className="row mt-4 mb-4">
                                <div className="col">
                                </div>
                                { esPacienteDoctorActual ? 
                                    <div className="col text-center">
                                        
                                        <button
                                            type="submit"
                                            className="btn btn-primary">{ ( entidadId > 0 && !cargando ) ? 'Actualizar ' : 'Guardar ' }
                                            {
                                                cargando ? 
                                                <span className="spinner-border" role="status" aria-hidden="true"></span>
                                                :
                                                null
                                            }
                                            
                                        </button> 
                                    </div>
                                : null
                                }
                                <div className="col text-center">
                                    <Link
                                        type="button"
                                        className="btn btn-primary"
                                        disabled={ entidadId === 0 ? true : false }
                                        to={ entidadId === 0 ? '#' : {
                                            pathname: '/citas',
                                            state: { 
                                                pacienteId: entidadId,
                                                pacienteNombre: `${nombre} ${apellido_paterno} ${apellido_materno}`,
                                                doctorId: doctorId
                                            }
                                        }}
                                    >Programar cita</Link>
                                </div>
                                <div className="col">
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>            
        </div>
     );
}
 
export default Prospecto;